module.exports = __webpack_public_path__ + "img/train-success-icon.bcee15cf.png";